import PropTypes from 'prop-types'
import { css } from '@emotion/react'

import { Flex } from 'shared/ui'
import Label from '../Label'
import Row from '../IndentedRow'
import Input from './Input'

const flexStyle = css`
  flex: 1 0 100%;
`

const SubjectRow = ({
  className,
  draft,
  onChange,
  onEnter,
  startInEditMode,
  subject,
  ticketId,
}) => {
  return (
    <Row css={flexStyle} className={className}>
      <Label>Subject:</Label>
      <Flex className="grui ml-3 flex-1">
        <Input
          subject={subject}
          draft={draft}
          onChange={onChange}
          onEnter={onEnter}
          startFocused={startInEditMode}
          ticketId={ticketId}
        />
      </Flex>
    </Row>
  )
}

SubjectRow.propTypes = {
  draft: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func.isRequired,
  onEnter: PropTypes.func,
}

SubjectRow.defaultProps = {
  draft: null,
  onEnter: undefined,
}

export default SubjectRow
